"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckBobtail = function SvgIconTruckBobtail(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck bobtail icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Bobtail Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40.47 33.6h2.31s3.22-.54 3.19-3.54v-7.52l-4.15-3.27-3.12-8.93-.06-.15C38.35 9.47 37.66 9 36.89 9h-16.1v18.05H8c-2.76 0-5 2.24-5 5v1.54h.05c-.02.16-.05.31-.05.46 0 2.76 2.24 5 5 5s5-2.24 5-5a5.01 5.01 0 005 5c2.76 0 5-2.24 5-5 0-.16-.03-.3-.05-.46h7.61c-.01.15-.05.3-.05.46 0 2.76 2.24 5 5 5s5-2.24 5-5c.01-.15-.03-.3-.04-.45zm-30.25 1.02c-.19.8-.85 1.46-1.65 1.66a2.296 2.296 0 01-1.14-4.45c1.7-.41 3.2 1.08 2.79 2.79zm10 0c-.19.8-.85 1.46-1.65 1.66a2.296 2.296 0 01-1.14-4.45c1.7-.41 3.2 1.08 2.79 2.79zm17.52-.25c-.19.8-.85 1.46-1.65 1.66-1.71.42-3.22-1.1-2.79-2.81.2-.8.86-1.45 1.66-1.64a2.295 2.295 0 012.78 2.79zm-9.68-13.8v-8.25h7.34c.47 0 .87.32.98.78l1.68 7.47h-10z"
  }));
};

var _default = SvgIconTruckBobtail;
exports.default = _default;